export const userPatternConstants = {
  NAME_PATTERN: /^.{3,30}$/,
  PASSWORD_PATTERN: /^(?=.*\d)(?=.*[a-zA-Z]).{6,256}$/,
  EMAIL_PATTERN:
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
}
